<template>
  <el-select class="select-default max-step-width payment-type-select"
             :value="value"
             :loading="loading"
             @change="onChange"
             :placeholder="$t('generic.select')"
             v-bind="$attrs">
    <el-option v-for="payment in paymentTypes"
               class="select-default"
               :key="payment.id"
               :label="payment.name"
               :value="payment.id">
    </el-option>
  </el-select>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import PaymentTypeService from 'src/services/PaymentTypeService'

  export default {
    name: 'payment-type-select',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: [String, Number, Object]
      },
      label: {
        type: String
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        paymentTypes: []
      }
    },
    methods: {
      onChange (val) {
        this.$emit('change', val)
      }
    },
    async created () {
      try {
        this.loading = true
        let {data} = await PaymentTypeService.get()
        this.paymentTypes = data
        this.$emit('values-change', data)
      } finally {
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">
  .payment-type-select {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
